import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { widgetEditMode, IReturnChangesWidgetEditForm, IDragFileBrowseData, dataURLtoBlob, getFormatedDataVideoLayout, layoutTypesVideo } from 'na-lib';
import { CommentsService } from 'src/app/service/comments.service';
import { SettingsService } from 'src/app/service/settings.service';
import { UploadService } from 'src/app/service/upload.service';
import { checkIfFieldDisabled } from 'src/app/shared/shared';
import { supportUrlStructure } from 'src/app/supportUrls';
import { urlInvalidCharactersValidator } from 'src/app/validators/formValidators.dt';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-videos-edit-form',
    templateUrl: './videos-edit-form.component.html',
    styleUrl: './videos-edit-form.component.css',
    standalone: false
})
export class VideosEditFormComponent {
  @Input() data:widgetEditMode;
  @Output() returnChanges = new EventEmitter<IReturnChangesWidgetEditForm>();
  @ViewChild('canvasElement') canvasElementRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('media') myVideo: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>
  @Output() formChange = new EventEmitter<FormGroup>();
  userHasBetaWidgetRole = false
  defaultLanguage:string
  oldData:any
  videoData:any
  widgetNumber:any
  passId:any
  url:any
  disableFilters = false
  translationModeOriginal = false
  dragFileData: IDragFileBrowseData
  videoEditForm!: FormGroup
  urlData:any
  urlRegex = /^(?:\$\{[A-Za-z0-9._:-]+\}|#\S+|child:[^\s]+|dpp:\/\/main|(?:https?:\/\/|context:\/\/|pass:\/\/|content:\/\/|task:\/\/|tridy:\/\/)\S+)$/;
  urlRegexDoc = /^(?:\$\{[^}]+\}|pass:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+)$/;
  urlRegexDynamic = /^\$\{[A-Za-z0-9._:-]+\}$/;

  thumbnailUrl:any
  returnUrlData:string
  dynamicUrl = false
  addUrl = false
  coverImageFile:any
  changes=false
  noUrl=false
  layout = 'standard'
  type = 'video'
  layoutSelected = 'standard'
  trackByLayout = (_: number, item: any) => item.value;
  layoutTypes = layoutTypesVideo
  videoType:string
  private destroy$ = new Subject<void>();

  constructor( private settingsService: SettingsService,
    private fb: FormBuilder,
    private translate:TranslateService,
    private commentService:CommentsService,
    private uploadService: UploadService,
  ) { }

  ngOnInit():void{
    if(this.settingsService.checkIfBetaRoleAccess())
      this.userHasBetaWidgetRole = true

    this.defaultLanguage = this.data.defaultLanguage
    this.videoData=this.data.values
    this.oldData=this.videoData
    this.url=this.oldData.url
    this.passId = this.data.passId
    this.widgetNumber= this.data.widget

    if(this.data.translateMode){
      this.disableFilters = true
      let translateData = this.data.translateData
      const {fields, originalLanguageData, defaultLanguageWidgetData, valuesTranslated, selectedLanguage, values} = translateData

      if(translateData.originalLanguageData){
        this.translationModeOriginal = true
        this.dragFileData = translateData.dragFileDataOriginal
        this.initTranslateEditData( defaultLanguageWidgetData, valuesTranslated, originalLanguageData, [],selectedLanguage)
      }else{
        this.translationModeOriginal = false

        this.dragFileData = translateData.dragFileData
        this.initTranslateEditData(values,valuesTranslated, originalLanguageData, fields, selectedLanguage)
      }
    }
    else{
      this.dragFileData = {
        calledFrom: VideosEditFormComponent,
        calledFromData:{
          passId: this.passId,
          widgetNumber:this.widgetNumber,
          widget: "video",
        },
        enableDragDrop: true,
        enableBrowse:true,
        enableMedia:true,
        enableEnterUrl:true,
        enableMultipleDragDrop:false,
        supportedFileTypes:['video/*'],
        supportedFileAccept:"video/*",
        maxSizeInBytes: 25 * 1024 * 1024, // 2 MB size limit for compression,
        maxAllowedSizeInBytes:undefined,
        returnSupportUrl: undefined,
        returnUrlData: undefined,
        enterUrl:false,
        returnUrlType:undefined
      }
      this.initWidgetEdit()
    }

  }

  initTranslateEditData(data, valuesTranslated, originalLanguageData, fields, selectedLanguage){
    let {id, filter,url, widgetStyle,showMoreIndicator, type, layout, previewPicture, copyright, title, subtitle, autoPlay, autoRePlay, muted, videoControls,size, name,altTitle, coverImageURL } = data
    
    this.layout = layout ? layout : (type === 'video' ? 'standard' : (type === 'billboardVideo' ? 'billboard' : (type === 'splashVideo' ? 'splash' : 'standard')))
    this.layoutSelected = layout
    this.videoType = (type === 'video') ? 'video' : 'video'
    type = 'video'

    if( showMoreIndicator == true)
    showMoreIndicator = true

    if(showMoreIndicator == false )
      showMoreIndicator = false

    if(showMoreIndicator == undefined)
      showMoreIndicator = true

    if(url)
    this.urlData = supportUrlStructure(url, this.passId, this.settingsService.contextId$)

    if(!originalLanguageData){
      if(layout == 'standard'){
        url = valuesTranslated[selectedLanguage +'.'+id+'.url']
        title = valuesTranslated[selectedLanguage +'.'+id+'.title']
        subtitle = valuesTranslated[selectedLanguage +'.'+id+'.subtitle']
        altTitle = valuesTranslated[selectedLanguage +'.'+id+'.altTitle']
      }

      if(layout === 'splash' || layout === 'billboard'){
        altTitle = valuesTranslated[selectedLanguage +'.'+id+'.altTitle']
        url = valuesTranslated[selectedLanguage +'.'+id+'.url']
      }

    }

    this.videoEditForm =  this.fb.group({
      id:[{value: id? id : undefined, disabled: checkIfFieldDisabled('id', fields, originalLanguageData)}],
      layout:[{value: layout ? layout : undefined, disabled: checkIfFieldDisabled('layout', fields, originalLanguageData)}],
      //url: [{value:url ? url : undefined , disabled: checkIfFieldDisabled('url', fields, originalLanguageData)}],
      url: [
        { value: url ? url : undefined, disabled: checkIfFieldDisabled('url', fields, originalLanguageData) },
        [ Validators.pattern(this.urlRegex), urlInvalidCharactersValidator() ]
      ],
      previewPicture: [{value:previewPicture ? previewPicture : undefined , disabled: checkIfFieldDisabled('previewPicture', fields, originalLanguageData)}],
      copyright: [{value:copyright ? copyright : undefined , disabled: checkIfFieldDisabled('copyright', fields, originalLanguageData)}],
      title: [{value:title ? title: undefined , disabled: checkIfFieldDisabled('title', fields, originalLanguageData)}],
      type: [{value:type ? type: undefined,disabled: checkIfFieldDisabled('type', fields, originalLanguageData)}],
      subtitle: [{value:subtitle ? subtitle: undefined , disabled: checkIfFieldDisabled('subtitle', fields, originalLanguageData)}],
      showMoreIndicator: [{value:showMoreIndicator ? showMoreIndicator: undefined , disabled: checkIfFieldDisabled('showMoreIndicator', fields, originalLanguageData)}],
      autoPlay: [{value:autoPlay ? autoPlay : false , disabled: checkIfFieldDisabled('autoPlay', fields, originalLanguageData)}],
      autoRePlay: [{value:autoRePlay ? autoRePlay : false  , disabled: checkIfFieldDisabled('autoRePlay', fields, originalLanguageData)}],
      muted: [{value:muted ? muted : false , disabled: checkIfFieldDisabled('muted', fields, originalLanguageData)}],
      videoControls: [{value:videoControls ? videoControls : false , disabled: checkIfFieldDisabled('videoControls', fields, originalLanguageData)}],
      size: [{value:size ? size : undefined , disabled: checkIfFieldDisabled('size', fields, originalLanguageData)}],
      name: [{value:name ? name : undefined , disabled: checkIfFieldDisabled('name', fields, originalLanguageData)}],
      filter: [{value:filter ? filter : undefined , disabled: checkIfFieldDisabled('filter', fields, originalLanguageData)}],
      widgetStyle: [{value:widgetStyle ? widgetStyle : undefined , disabled: checkIfFieldDisabled('widgetStyle', fields, originalLanguageData)}],
      coverImageURL: [{value:coverImageURL ? coverImageURL : undefined , disabled: checkIfFieldDisabled('coverImageURL', fields, originalLanguageData)}],      
      altTitle :[{value:altTitle ? altTitle : undefined , disabled: checkIfFieldDisabled('altTitle', fields, originalLanguageData)}]
    })


    this.videoEditForm.get('url')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value:any)=> {
      if(value?.match(/\${(.+)\}/))
        this.dynamicUrl = true
      else
        this.dynamicUrl = false
      this.setFieldValidator('url', value)
    })

    this.videoEditForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( value => {
      if(!originalLanguageData){
        this.returnChanges.emit({
          type:"video",
          form: this.videoEditForm,
          validForm: this.videoEditForm.valid,
          translations: {url:value.url, title: value.title, subtitle: value.subtitle, altTitle: value.altTitle},
          saveDisabled: false
        })
      }
    })

    this.videoEditForm.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.formChange.emit(this.videoEditForm);
    });
  }

  initWidgetEdit(){
    const {id, filter,url, widgetStyle, layout, previewPicture, coverImageURL, copyright, title, subtitle, autoPlay, autoRePlay, muted, videoControls,size, name, altTitle} = this.videoData
    let {showMoreIndicator , type} = this.videoData

    if( showMoreIndicator == true)
      showMoreIndicator = true

    if(showMoreIndicator == false )
      showMoreIndicator = false

    if(showMoreIndicator == undefined)
      showMoreIndicator = true

    if(url )
      this.supportUrl(url)
    
    this.layout = layout ? layout : (type === 'video' ? 'standard' : (type === 'billboardVideo' ? 'billboard' : (type === 'splashVideo' ? 'splash' : 'standard')))
    this.layoutSelected = this.layout

    this.videoType = (type === 'video') ? 'video' : 'video'
    type = 'video'

    this.videoEditForm = this.fb.group({
      id:[{ value: id ? id : undefined, disabled:false}],
      layout:[{ value: this.layout ? this.layout : 'standard', disabled:false}],
      type:[{ value: type ? type : undefined, disabled:false}],
      url:[{ value: url ? url : undefined, disabled:false},[Validators.required, Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]],
      previewPicture:[{ value: previewPicture ? previewPicture : undefined, disabled:false}],
      copyright:[{ value: copyright ? copyright : undefined, disabled:false}],
      title:[{ value: title ? title : undefined, disabled:false}],
      subtitle:[{ value: subtitle ? subtitle : undefined, disabled:false}],
      autoPlay:[{ value: autoPlay ? autoPlay : false, disabled:false}],
      autoRePlay:[{ value: autoRePlay ? autoRePlay : false, disabled:false}],
      muted:[{ value: muted ? muted : false, disabled:false}],
      videoControls:[{ value: videoControls ? videoControls : false, disabled:false}],
      size:[{ value: size ? size : undefined, disabled:false}],
      name:[{ value: name ? name : undefined, disabled:false}],
      filter:[{ value: filter ? filter : undefined , disabled:false}],
      widgetStyle:[{ value: widgetStyle ? widgetStyle : undefined, disabled:false}],
      coverImageURL:[{ value: coverImageURL ? coverImageURL : undefined, disabled:false}],
      altTitle:[{ value: altTitle ? altTitle : undefined, disabled:false}],
      showMoreIndicator:[{value: showMoreIndicator, disabled:false}],
    })

    this.loadThumbnail(this.videoEditForm.value.coverImageURL)

    this.videoEditForm.get('url')!.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(async (value: string) => {
      const ctrl = this.videoEditForm.get('url');
      this.setFieldValidator('url', value)

      // clear preview if empty
      if (!value) {
        this.urlData = undefined;
        return;
      }

      // no preview on placeholder
      if (value?.match(/\${(.+)\}/)) {
        this.dynamicUrl = true;
        this.urlData = undefined;
        return;
      } else
        this.dynamicUrl = false;

      // no resolve if invalid
      if (ctrl?.invalid)
        return;

      // buiild preview on valid url
      try {
        if ( value.includes('https://') || value.includes('http://') || value.includes('pass://') || value.includes('tridy://') || value.includes('context://') )
          this.urlData = supportUrlStructure( value, this.passId, this.settingsService.contextId$ );
        else
          this.urlData = value;
        
      } catch (e) {
        this.urlData = undefined;
      }

      const video = document.getElementById('singleVideoBV') as HTMLVideoElement;
      video?.load();
    });

    this.videoEditForm.get('layout')!.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(async (value: string) => {
      this.layoutSelected = value
    });

    this.videoEditForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( async values => {
      const {size} = values

      if(size?.length==0 || !size || (size && size[0]==0 && size[1]==0))
        await this.onVideoMetadataVideo()

        const data = getFormatedDataVideoLayout(values)
      this.returnChanges.emit({
          type:"video",
          form: this.videoEditForm,
          validForm: this.videoEditForm.valid,
          data: data,
          saveDisabled: !this.videoEditForm.valid || !values.url
        }
      )
    })

    if(this.urlData) {
      if(!this.videoEditForm.value.coverImageURL){
        this.updateFrame()
      }
    }
  }

  setFieldValidator(field, value) {
    if (!value) return;

    if (value.match(/\${(.+)\}/)){
      this.videoEditForm.get(field)?.setValidators([ Validators.pattern(this.urlRegexDynamic)]);
      this.videoEditForm.get(field)?.updateValueAndValidity({ emitEvent: false });
    } else {
      this.checkPattern_url(field)
    }
  }

  selectLayout(layout: string) {
    this.videoEditForm.patchValue({ layout });
    this.layoutSelected = layout;
  }

  checkPattern_url(field){
    const fiedlValue:any = this.videoEditForm.get(field)
    if (fiedlValue){
      try {
        const imgUrl = new URL(fiedlValue)

        if(imgUrl.protocol === "pass:" )
          this.videoEditForm.get(field)?.setValidators([Validators.pattern(this.urlRegexDoc), urlInvalidCharactersValidator()]);

        if(imgUrl.protocol === "https:" || imgUrl.protocol === "http:" || imgUrl.protocol === "context:" || imgUrl.protocol === "tridy:")
          this.videoEditForm.get(field)?.setValidators([Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]);

      this.videoEditForm.updateValueAndValidity()
      } catch(e){}
    }
  }

  typeURL(){
    this.addUrl = true
    this.urlData = './../../assets/img/default.jpg';
  }

  updateFrame() {
    const videoElement: HTMLVideoElement = this.myVideo.nativeElement;
    const canvas: HTMLCanvasElement = this.canvasElementRef.nativeElement;
    const context = canvas.getContext('2d');
    
    // Set canvas dimensions
    const scale = 0.8;
    canvas.width = Math.floor(videoElement.videoWidth * scale);
    canvas.height = Math.floor(videoElement.videoHeight * scale);
    
    // Draw
    context?.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
    // Convert
    const imageUrl = canvas.toDataURL('image/jpeg', 0.8);

    // Convert to blob
    const blob = dataURLtoBlob(imageUrl);
    // Create file
    const jpegBlob = new Blob([blob], { type: 'image/jpeg' });
    let videoName =  this.videoEditForm.get('url')?.value;
    if (videoName && videoName.length > 0) {
      if (videoName.startsWith('http://') || videoName.startsWith('https://'))
        videoName = videoName.split('/').pop();
      else
        videoName = videoName.replace('pass://', '').replace('context://Media/', '').split('.').slice(0, -1).join('.');
      
    }
    const imageFile = new File([jpegBlob], `${videoName}.jpg`, { type: 'image/jpeg' });

    // Store the frame
    this.coverImageFile = imageFile;
    this.uploadVideoThumbnail()
  }

  async uploadVideoThumbnail() {
    try {
      const uploadURL = await this.uploadService.uploadVideoCoverImage(this.passId, this.coverImageFile, this.widgetNumber);
      if (uploadURL) {
        this.changes = true
        this.videoEditForm.patchValue({coverImageURL: uploadURL})
        this.noUrl = false
        this.loadThumbnail(uploadURL)
      }
    } catch (error) {
      console.error(error);
      const message = this.translate.instant("SnackBarConstants.UPLOAD_IMG_FAILED");
      this.commentService.addSnackBar.emit(message);
    }
  }

  loadThumbnail(url: string) {
    if(url){
      try{
        this.thumbnailUrl = new URL(url)
        const firebaseUrl = supportUrlStructure(url ,this.passId, this.settingsService.contextId$)
        this.thumbnailUrl=firebaseUrl
      }catch(error){
        this.thumbnailUrl = undefined
        this.commentService.addSnackBar.emit("LOADING VIDEO THUMBNAIL FAILED");
        console.error(error)
      }
    }
  }

  supportUrl(url){
    this.urlData = url
    if(url){
      try{
        if(url.includes('https://') || url.includes('http://') || url.includes('pass://') || url.includes('tridy://') || url.includes('context://')){
          const firebaseUrl = supportUrlStructure(url ,this.passId, this.settingsService.contextId$)
          this.urlData=firebaseUrl          
        }else
        this.urlData = url
      }catch(error){}
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get hasAnyVideo(): boolean {
    const urlCtrlValue = this.videoEditForm.get('url')?.value;
    return !!(urlCtrlValue || this.urlData || this.url);
  }

  delete(){
    this.url = undefined
    this.urlData = ""
    this.returnUrlData = undefined
    this.videoEditForm.patchValue({url:undefined, size:undefined, altTitle:undefined})
  }

  checkNewUrl(){
    this.url = this.videoEditForm.value.url
    this.supportUrl(this.videoEditForm.value.url)
  }

  onVideoMetadataVideo(event?: Event): void {
    try{
      const videoElement: HTMLVideoElement = this.myVideo.nativeElement;
      const width: number = videoElement.videoWidth;
      const height: number = videoElement.videoHeight;
      this.videoEditForm.patchValue({size : [ width, height]},  { emitEvent: false })

    } catch(error){
      this.commentService.progressSpin.emit(false)
    }
  }
  //---------------------------------------------------

  returnChangesFilters($event){
    this.videoEditForm.patchValue({filter: $event.newFilters})
  }

  returnChangesStyle($event){
    this.videoEditForm.patchValue({widgetStyle: $event.newStyle})
  }

  returnChangesDragFileBrowseUI($event){
    if($event){
      const { returnSupportUrl, returnUrlData, enterUrl } = $event;
      this.dragFileData = $event
      this.dragFileData.returnSupportUrl = undefined
      this.dragFileData.returnUrlData = undefined
      if(enterUrl){
        this.typeURL()
      }else{
        this.addUrl = false
        this.urlData = undefined
      }

      if(returnUrlData){
        this.returnUrlData = returnUrlData
        this.urlData = returnUrlData
      }
      // update thumbnail on video upload
      setTimeout(() => this.updateFrame(), 500);

      if(returnSupportUrl){
        this.url = returnSupportUrl
        this.videoEditForm.patchValue({ url: returnSupportUrl })
      }
    }
  }
    
}
